import { render, staticRenderFns } from "./BlockType19List.vue?vue&type=template&id=273ad595&scoped=true"
import script from "./BlockType19List.vue?vue&type=script&lang=ts"
export * from "./BlockType19List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType19List.vue?vue&type=style&index=0&id=273ad595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ad595",
  null
  
)

export default component.exports